import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';
import { typographyTokens } from '../typography-tokens';
import dimensions from '../dimensions';

export const MuiMenuItemTheme = (mode: PaletteMode): Components<Theme>['MuiMenuItem'] => {
  const { componentTokens } = themePalette(mode);
  const { spacing } = dimensions;

  return {
    styleOverrides: {
      root: {
        width: '100%',
        cursor: 'pointer',
        fontSize: typographyTokens.fontSizes.sm,
        padding: spacing(3), // 12px
        marginTop: 1,
        marginBottom: 1,
        position: 'relative',
        border: '1px solid',
        transition: 'background-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
        wordBreak: 'break-all',
        color: componentTokens.selectMenuItems.color.item.text.row.resting,
        borderColor: componentTokens.selectMenuItems.color.item.stroke.row.resting,
        backgroundColor: componentTokens.selectMenuItems.color.item.background.row.resting,
        '& .MuiSvgIcon-root': {
          color: componentTokens.selectMenuItems.color.item.assets.row.resting,
        },
        '&:hover': {
          backgroundColor: componentTokens.selectMenuItems.color.item.background.row.hover,
          borderColor: componentTokens.selectMenuItems.color.item.stroke.row.hover,
          color: componentTokens.selectMenuItems.color.item.text.row.hover,
          '& .MuiSvgIcon-root': {
            color: componentTokens.selectMenuItems.color.item.assets.row.hover,
          },
        },
        // This is a fix for link menu items
        '& .MuiMenuItem-root:hover': {
          borderColor: 'transparent',
          backgroundColor: 'transparent',
        },
        '&.Mui-focusVisible': {
          backgroundColor: componentTokens.selectMenuItems.color.item.background.row.hover,
          borderColor: componentTokens.selectMenuItems.color.item.stroke.row.hover,
        },
        // Selected state
        '&.Mui-selected': {
          backgroundColor: componentTokens.selectMenuItems.color.item.background.row.selected,
          borderColor: componentTokens.selectMenuItems.color.item.stroke.row.selected,
          color: componentTokens.selectMenuItems.color.item.text.row.selected,
          fontWeight: typographyTokens.fontWeights.medium,
          '&.Mui-focused': {
            backgroundColor: componentTokens.selectMenuItems.color.item.background.row.selected,
            borderColor: componentTokens.selectMenuItems.color.item.stroke.row.selected,
          },
        },
        // Disabled state
        '&.Mui-disabled': {
          opacity: 0.4,
        },
        // Nested items (with data-nested attribute)
        '&[data-nested="true"]': {
          paddingLeft: spacing(22), // 88px
        },
      },
    },
  };
};
